import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { GridContentAlignment, GridDirection, GridJustification, GridWrap } from '@material-ui/core/Grid/Grid';

const styles = {
	grid: {
		margin: '0 -12px',
		width: 'calc(100% + 24px)',
	},
};

const useStyles = makeStyles(styles);

interface IGridContainerProps {
	className?: string;
	children: React.ReactElement | string | React.ReactElement[];
	justify?: GridJustification;
	alignContent?: GridContentAlignment;
	wrap?: GridWrap;
	direction?: GridDirection;
	id?: string;
}

const GridContainer = (props: IGridContainerProps) => {
	const classes = useStyles();
	const { children, className, wrap, ...rest } = props;
	return (
		<Grid container wrap={wrap} justify="space-evenly" {...rest} className={classes.grid + ' ' + className}>
			{children}
		</Grid>
	);
};

export default GridContainer;
